/*
layout  string  "Full" "Pattern only" "Pattern and cut" "AFD and pattern only" "AFD only" "Invisible"
apertureWidth   number
apertureLength  number
AFD_Width   number
AFD_Length  number
AFD_GaussianTaper   number
Npts    number
analysisSpan    number
phasePointingX  number
phasePointingY  number
showControls    boolean
lookatY number
cutNpoints  number
cutSpan  number
cutTheta  number
cutCenterOffset  number
cutX    r/o Array of numbers
cutValues    r/o Array of numbers
showCut    boolean
apertureShape   string "Circular" "Elliptical" "Square" "Rectangular"
AFD_Shape   string "Circular" "Elliptical" "Square" "Rectangular"
taperType   string "Gaussian" "Flat"
syncPanelViews     Locks pan and tilt of the two panels together

*/ 

import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import UniversalRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/universal-render-space"; // For 3D:
import XY3DSurface3_geom from "SATPROF_LIBRARY/ThreeDParts/XY3DSurface3_geom"
import * as THREE from 'three';
import SigProc from "SATPROF_UTILS/SigProc"; 
import Complex from "SATPROF_UTILS/Complex"; 
import RadioButtonGroup_p from "SATPROF_LIBRARY/RadioButtonGroup/RadioButtonGroup_p"; 
import Slider_p from "SATPROF_LIBRARY/Slider/Slider_p"; 
import XYPlot_p from "SATPROF_LIBRARY/XYPlot/XYPlot_p"; // Needed for 3D text
import Dial_p from "SATPROF_LIBRARY/Dial/Dial_p"; 
import Checkbox_p from "SATPROF_LIBRARY/Checkbox/Checkbox_p"; 
import { Line2 } from "three/examples/jsm/lines/Line2";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";
import PolyLine_grp from "SATPROF_LIBRARY/ThreeDParts/PolyLine_grp";

export default class AntennaPatternFourierSimulator_p extends AnimateProxyBase{
 
    private animateSpace:AnimateRenderSpace
	public universal_rs2 : UniversalRenderSpace;
	public universal_rs1 : UniversalRenderSpace;

    private apertureWidth_sldr_p:Slider_p;
    private apertureLength_sldr_p:Slider_p;
    private AFDwidth_sldr_p:Slider_p;
    private AFDlength_sldr_p:Slider_p;
    private AFDtaper_sldr_p:Slider_p;
    private phaseX_sldr_p:Slider_p;
    private phaseY_sldr_p:Slider_p;
    private analysisSpan_sldr_p:Slider_p;
    private nPts_sldr_p:Slider_p;

    private apertureShape_rb_p:RadioButtonGroup_p;
    private taperType_rb_p:RadioButtonGroup_p;
    private AFDshape_rb_p:RadioButtonGroup_p;

    private xyPlot_p:XYPlot_p;
    private cutDataArray:Array<number>;
    private cutPlotNpts:number = 128;    
    private cutDial_p:Dial_p;
    private cutSlider_p:Slider_p;
    private cutEnable_cb_p:Checkbox_p;

	public patternTop_g:XY3DSurface3_geom
	public patternTop_mat:THREE.MeshPhongMaterial
	public patternTop_m:THREE.Mesh

	public patternBot_g:XY3DSurface3_geom
	public patternBot_mat:THREE.MeshPhongMaterial
	public patternBot_m:THREE.Mesh

    public AFD_Xvalues:Array<number>;
    public AFD_Yvalues:Array<number>;
    public AFD_Zvalues:Array<Array<number>>;
    public AFD_XYZvalues:Array<Array<any>>;

    public patternAlphaValues:Array<number>;
    public patternBetaValues:Array<number>;
    public patternZvalues:Array<Array<number>>;
    public patternXYZvalues:Array<Array<any>>;

    public dmin:number;
    public dmax:number;
    private _ds:number; // Spatial domain (d) spacing
    private _ks:number; // Spatial radial frequency (k) spacing
    private lambda:number = 20; //mm
 

	public AFD_Top_g:XY3DSurface3_geom
	public AFD_Top_mat:THREE.MeshPhongMaterial
	public AFD_Top_m:THREE.Mesh

	public AFD_Bot_g:XY3DSurface3_geom
	public AFD_Bot_mat:THREE.MeshPhongMaterial
	public AFD_Bot_m:THREE.Mesh

	public AFD_Base_g:THREE.PlaneGeometry
	public AFD_Base_mat:THREE.MeshBasicMaterial
	public AFD_Base_m:THREE.Mesh

	public aperture_g:any; //// check this
	public aperture_mat:THREE.MeshBasicMaterial
	public aperture_m:THREE.Mesh

    private patternCutLine_pl:PolyLine_grp;
    private _cutNpoints:number = 512;
    private _cutSpan:number = 50; //degrees
    private _cutValues:Array<number>;
    private _cutX:Array<number>;

	private v1:Array<Array<Complex>>;

    private AFD_Scales:THREE.Group;
    private patternScales:THREE.Group;
    private _patternGaindBPerDiv:number = 10;
    private _patternDegPerDiv:number = 5;

    private _magMax:number = 800;
    private _AFD_MagPerDiv = 100;
    private _AFD_DperDiv = 200;

    private _anStageWidth:number = 2388; // Stage width (animateSpace)
    private _anStageHt:number = 1080; // Stage height
    private _panelX:number = 500;
    private _panelY:number = 100;
    private _panelWidthEach:number = 900;
    private _panelXspacing:number = 50;
    private _panelHeight:number = 700;
    private _lookatY = 20;

    private _layout:string;
    private _stageWidth:number = 2388;
    private _stageHeight:number = 1080;

    private _showLeftSideDetails:boolean = true;
    private _showRightSideDetails:boolean = true;

    private _syncPanelViews:boolean = false;


    onFrameZero(){
        super.onFrameZero();

        this.animateSpace = this.extraData.animateSpace;       
        this.universal_rs1 = this.extraData.universal_rs1;       
        this.universal_rs2 = this.extraData.universal_rs2;       

        this.initialize();

    }
	public initialize(){
		// Put all remaining init code here.
    
        this.stageSymbol.placeholder.visible = false;

       //                 anStageWidth, anStageHt, panelX, panelY, panelWidthEach, panelXspacing, panelHeight
        this.positionPanels(2388, 1080, 450, 100, 600, 50, 600); 

        this.universal_rs1.uniCamHandler.pixelSnap = 0.2; // Gives 0.2 deg snap res
        this.universal_rs1.uniCamHandler.distance = 3300;
        this.universal_rs1.uniCamHandler.pan = 45;
        this.universal_rs1.uniCamHandler.tilt = -30;
        this.universal_rs1.setZIndex(-1); // Put the 3JS canvas at the back
        this.universal_rs1.backgroundColor = "DarkSlateGray"; //"";
        this.animateSpace.passEventsTo(this.universal_rs1);

        this.universal_rs2.uniCamHandler.pixelSnap = 0.2; // Gives 0.2 deg snap res
        this.universal_rs2.uniCamHandler.distance = 170;
        this.universal_rs2.uniCamHandler.pan = 45;
        this.universal_rs2.uniCamHandler.tilt = -30;        
        this.universal_rs2.setZIndex(-1); // Put the 3JS canvas at the back
        this.universal_rs2.backgroundColor = "DarkSlateGray";
        this.animateSpace.passEventsTo(this.universal_rs2);

		this.patternTop_m = new THREE.Mesh();
		this.patternBot_m = new THREE.Mesh();
		this.AFD_Top_m = new THREE.Mesh();
		this.AFD_Bot_m = new THREE.Mesh();
        this.AFD_Base_m = new THREE.Mesh();
        this.aperture_m = new THREE.Mesh();
        this.patternCutLine_pl = new PolyLine_grp();
        this.patternCutLine_pl.visible = false;

        this.universal_rs1.myscene.add(this.AFD_Top_m);
        this.universal_rs1.myscene.add(this.AFD_Bot_m);
        this.universal_rs1.myscene.add(this.AFD_Base_m);
        this.universal_rs1.myscene.add(this.aperture_m);

        this.universal_rs2.myscene.add(this.patternTop_m);
        this.universal_rs2.myscene.add(this.patternBot_m);
        this.universal_rs2.myscene.add(this.patternCutLine_pl);
        
        this.configureRadioButtons();
        this.configureSliders();
        this.configureDials();
        this.configureCheckBoxes();

        let axesHelper1:THREE.AxesHelper = new THREE.AxesHelper( 2500 );
        //this.universal_rs1.myscene.add(axesHelper1);

        let axesHelper2:THREE.AxesHelper = new THREE.AxesHelper( 50 );
        //this.universal_rs2.myscene.add(axesHelper2);
        let axesHelper2a:THREE.AxesHelper = new THREE.AxesHelper( 50 );
        //this.universal_rs2.myscene.add(axesHelper2a);
        axesHelper2a.position.y = 20;
        axesHelper2a.position.x = 10;
        axesHelper2a.position.z = 10;

        this.AFD_Scales = new THREE.Group();
        this.universal_rs1.myscene.add(this.AFD_Scales);
        this.patternScales = new THREE.Group();
        this.universal_rs2.myscene.add(this.patternScales);
        this.generateScales();

        // Load initial AFD function:
        let maxPoints:number = 512;
		let i:number;
		let j:number;
		this.v1 = [];
        for (i=0; i<maxPoints; i++){
			this.v1[i] = [];
        	for (j=0; j<maxPoints; j++){
                this.v1[i][j] = new Complex( 0, 0);
                // if (i>11 && i<23 && j >11 && j<23){
                //     this.v1[i][j] = new Complex( 100, 0);
                // } else {
                //     this.v1[i][j] = new Complex( 0, 0);
                // }
            }
        }		

		this.recalc3Dsurfaces();

        this.xyPlot_p = this.getProxy(
        "cut.xyPlot",  // stage symbol instance name (display tree path relative to current)
        XYPlot_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace});
        this.xyPlot_p.plotWidth = 600;
        this.xyPlot_p.plotHeight = 400;        
        this.xyPlot_p.setCurveColor(0, "red")
        this.xyPlot_p.xMin = -20;
        this.xyPlot_p.xMax = 20;
        this.xyPlot_p.yMin = -20;
        this.xyPlot_p.yMax = 50;
        this.xyPlot_p.xGridSpacing = 5;
        this.xyPlot_p.yGridSpacing = 5;
        this.xyPlot_p.xValueLabelSpacing = 2*this.xyPlot_p.xGridSpacing;
        this.xyPlot_p.xLabelsDecimalPlaces = 3;
        this.xyPlot_p.yValueLabelSpacing = 2*this.xyPlot_p.yGridSpacing;
        this.xyPlot_p.xLabelsDecimalPlaces = 1;        
        this.xyPlot_p.xAxisLegendText = "Azimuth";
        this.xyPlot_p.yAxisLegendText = "Gain";      

        window.addEventListener("DIAL_CHANGED", this.onControlChange.bind(this));
        window.addEventListener("SLIDERVALUECHANGE", this.onControlChange.bind(this));
        window.addEventListener("CLICKEDCHECKBOX", this.onControlChange.bind(this));
        window.addEventListener("CLICKEDRADIOBUTTON", this.onControlChange.bind(this));    

        // use setters to initialize the system:
        this.analysisSpan = 2000; 
        this.Npts = 128; 
        this.apertureShape = "Elliptical";
        this.AFD_Shape = "Elliptical";
        this.taperType = "Flat";
        this.apertureWidth = 1000;
        this.apertureLength = 700;
        this.AFD_Width = 200;
        this.AFD_Length = 150;
        this.AFD_GaussianTaper = 100;
	}

    private onControlChange(evt){
        //console.log("In onControlChange, ctrlName = "+evt.detail.name);
        if (evt.detail.name == "cutDial" || evt.detail.name == "cutSlider" || evt.detail.name == "cutEnable_cb"){
            //console.log("Calling updateCut");
            this.updateCut();
        } else {
            this.update();
        }
    }
    private update(){
        //console.log("In update()");
        this.stageSymbol.leftSideDetails_txt.text = this.leftSideDetails;
        this.stageSymbol.rightSideDetails_txt.text = this.rightSideDetails;

        this.stageSymbol.controls.analysisSpan_txt.text = "Span = "+this.analysisSpan.toFixed(0)+" mm";
        this.stageSymbol.controls.nPts_txt.text = "No. points = "+this.Npts.toFixed(0);

        this.apertureWidth_sldr_p.maximum = this.analysisSpan;
        this.apertureLength_sldr_p.maximum = this.analysisSpan;

        //this.phasePointingX = this.phaseX_sldr_p.value;
        this.stageSymbol.controls.phaseX_txt.text = "Phase pointing X = "+this.phasePointingX.toFixed(2)+"°";

        //this.phasePointingY = this.phaseY_sldr_p.value;
        this.stageSymbol.controls.phaseY_txt.text = "Phase pointing Y = "+this.phasePointingY.toFixed(2)+"°";

        switch (this.apertureShape_rb_p.selected){
            case 0:
                // Circular
                this.apertureLength_sldr_p.value = this.apertureWidth; // Force slider to match width
                this.stageSymbol.controls.apertureWidth_txt.text = "Width = "+this.apertureWidth.toFixed(0)+" mm";
                this.stageSymbol.controls.apertureLength_txt.text = "";
                this.apertureLength_sldr_p.visible = false;

                break;
            case 1:
                // Elliptical
                this.stageSymbol.controls.apertureWidth_txt.text = "Width = "+this.apertureWidth.toFixed(0)+" mm";
                this.stageSymbol.controls.apertureLength_txt.text = "Length = "+this.apertureLength.toFixed(0)+" mm";
                this.apertureLength_sldr_p.visible = true;
                break;
            case 2:
                // Square                
                this.apertureLength_sldr_p.value = this.apertureWidth; // Force slider to match width
                this.stageSymbol.controls.apertureWidth_txt.text = "Width = "+this.apertureWidth.toFixed(0)+" mm";
                this.stageSymbol.controls.apertureLength_txt.text = "";
                this.apertureLength_sldr_p.visible = false;
                break;        
            case 3:
                // Rectangular                
                this.stageSymbol.controls.apertureWidth_txt.text = "Width = "+this.apertureWidth.toFixed(0)+" mm";
                this.stageSymbol.controls.apertureLength_txt.text = "Length = "+this.apertureLength.toFixed(0)+" mm";
                this.apertureLength_sldr_p.visible = true;
                break;                 
        }
        switch (this.taperType_rb_p.selected){
            case 0:
                this.stageSymbol.controls.AFDtaper_txt.text = "Taper width = "+this.AFD_GaussianTaper.toFixed(0)+" mm";
                this.stageSymbol.controls.AFDtaper_txt.visible = true;
                this.AFDtaper_sldr_p.visible = true;

                this.AFDwidth_sldr_p.visible = false;
                this.AFDlength_sldr_p.visible = false;
                this.stageSymbol.controls.AFDwidth_txt.visible = false;
                this.stageSymbol.controls.AFDlength_txt.visible = false;
                this.AFDshape_rb_p.visible = false;
                break;
            case 1:
                // Flat
                this.AFDtaper_sldr_p.visible = false;
                this.stageSymbol.controls.AFDtaper_txt.visible = false;

                this.AFDshape_rb_p.visible = true;
                this.AFDwidth_sldr_p.visible = true;
                this.stageSymbol.controls.AFDwidth_txt.visible = true;
                this.stageSymbol.controls.AFDwidth_txt.text = "Width = "+this.AFD_Width.toFixed(0)+" mm";
                this.stageSymbol.controls.AFDlength_txt.text = "Length = "+this.AFD_Length.toFixed(0)+" mm";

                switch (this.AFDshape_rb_p.selected){
                    case 0:
                        // Circular
                        this.AFDlength_sldr_p.value = this.AFD_Width; // Force slider to match width
                        this.AFDlength_sldr_p.visible = false;
                        this.stageSymbol.controls.AFDlength_txt.visible = false;
                        break;
                    case 1:
                        // Elliptical
                        this.AFDlength_sldr_p.visible = true;
                        this.stageSymbol.controls.AFDlength_txt.visible = true;
                        break;    
                    case 2:
                        // Square                    
                        this.AFDlength_sldr_p.value = this.AFD_Width; // Force slider to match width
                        this.AFDlength_sldr_p.visible = false;
                        this.stageSymbol.controls.AFDlength_txt.visible = false;                        
                        break;    
                    case 3:
                        // Elliptical
                        this.AFDlength_sldr_p.visible = true;
                        this.stageSymbol.controls.AFDlength_txt.visible = true;                        
                        break;    
                }
                break;
        
        }
        this.recalc3Dsurfaces();
        this.updateCut();
        //this.updateText();

    }

    private updateCut(){
        //console.log("In updateCut")
        if (this.cutEnable_cb_p.selected){
            this.computeCut();
            this.patternCutLine_pl.visible = true;
            this.stageSymbol.cut.xyPlot.visible = true;
            this.stageSymbol.cut.cutDial.visible = true;
            this.cutSlider_p.visible = true; 
            this.stageSymbol.cut.cutDial_txt.visible = true;
            this.stageSymbol.cut.cutDial_txt.text = "Cut angle = "+this.cutTheta.toFixed(1)+"°";
            this.stageSymbol.cut.cutSlider_txt.visible = true;                       
            this.stageSymbol.cut.cutSlider_txt.text = "Cut offset = "+ this.cutCenterOffset.toFixed(1)+"°";                 
            this.xyPlot_p.loadCurve(0, this.cutX, this.cutValues);
            this.xyPlot_p.drawCurve(0);        
        } else {
            this.patternCutLine_pl.visible = false;
            this.stageSymbol.cut.xyPlot.visible = false;
            this.stageSymbol.cut.cutDial.visible = false;
            this.cutSlider_p.visible = false;
            this.stageSymbol.cut.cutDial_txt.visible = false;
            this.stageSymbol.cut.cutSlider_txt.visible = false;
        }
    }
    private configureRadioButtons(){
        let buttonFont:string = "20px Arial";

        this.apertureShape_rb_p = this.getProxy(
        "controls.apertureShape_rb",  // stage symbol instance name (display tree path)
        RadioButtonGroup_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.apertureShape_rb_p.nButtons = 4; // Put this first
        this.apertureShape_rb_p.name = "apertureShape_rb";
        this.apertureShape_rb_p.labelSide = "right";
        this.apertureShape_rb_p.selected = 0;
        this.apertureShape_rb_p.setLabelText(0, "Circular")
        this.apertureShape_rb_p.setLabelText(1, "Elliptical");
        this.apertureShape_rb_p.setLabelText(2, "Square");
        this.apertureShape_rb_p.setLabelText(3, "Rectangular");
        this.apertureShape_rb_p.labelFont = buttonFont;
        this.apertureShape_rb_p.labelColor = "black"; 

        this.taperType_rb_p = this.getProxy(
        "controls.taperType_rb",  // stage symbol instance name (display tree path)
        RadioButtonGroup_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.taperType_rb_p.nButtons = 2; // Put this first
        this.taperType_rb_p.name = "taperType_rb";
        this.taperType_rb_p.labelSide = "right";
        this.taperType_rb_p.selected = 0;
        this.taperType_rb_p.setLabelText(0, "Gaussian")
        this.taperType_rb_p.setLabelText(1, "Flat");
        this.taperType_rb_p.labelFont = buttonFont;
        this.taperType_rb_p.labelColor = "black"; 

        this.AFDshape_rb_p = this.getProxy(
        "controls.AFDshape_rb",  // stage symbol instance name (display tree path)
        RadioButtonGroup_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.AFDshape_rb_p.nButtons = 4; // Put this first
        this.AFDshape_rb_p.name = "AFDshape_rb";
        this.AFDshape_rb_p.labelSide = "right";
        this.AFDshape_rb_p.selected = 0;
        this.AFDshape_rb_p.setLabelText(0, "Circular")
        this.AFDshape_rb_p.setLabelText(1, "Elliptical");
        this.AFDshape_rb_p.setLabelText(2, "Square");
        this.AFDshape_rb_p.setLabelText(3, "Rectangular");
        this.AFDshape_rb_p.labelFont = buttonFont;
        this.AFDshape_rb_p.labelColor = "black"; 

    
    }
    private configureSliders(){

       this.cutSlider_p = this.getProxy(
        "cut.cutSlider",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.cutSlider_p.trackLength = 200;
        this.cutSlider_p.tickInterval = 5;
        this.cutSlider_p.minimum = -30;
        this.cutSlider_p.maximum = 30;
        this.cutSlider_p.snapInterval = .5; // Set this before setting value
        this.cutSlider_p.value = 0;
        this.cutSlider_p.enabled = true;
        this.cutSlider_p.enableWheel = false;
        this.cutSlider_p.name = "cutSlider";   
        this.stageSymbol.cut.cutSlider_txt.text = "Cut offset";  

        this.apertureWidth_sldr_p = this.getProxy(
        "controls.apertureWidth_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.apertureWidth_sldr_p.trackLength = 200;
        this.apertureWidth_sldr_p.tickInterval = 50;
        this.apertureWidth_sldr_p.minimum = 50;
        this.apertureWidth_sldr_p.maximum = 2000;
        this.apertureWidth_sldr_p.snapInterval = 1; // Set this before setting value
        this.apertureWidth_sldr_p.value = 1000;
        this.apertureWidth_sldr_p.enabled = true;
        this.apertureWidth_sldr_p.enableWheel = false;
        this.apertureWidth_sldr_p.name = "apertureWidth_sldr";  

        this.apertureLength_sldr_p = this.getProxy(
        "controls.apertureLength_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.apertureLength_sldr_p.trackLength = 200;
        this.apertureLength_sldr_p.tickInterval = 50;
        this.apertureLength_sldr_p.minimum = 50;
        this.apertureLength_sldr_p.maximum = 2000;
        this.apertureLength_sldr_p.snapInterval = 1; // Set this before setting value
        this.apertureLength_sldr_p.value = 1000;
        this.apertureLength_sldr_p.enabled = true;
        this.apertureLength_sldr_p.enableWheel = false;
        this.apertureLength_sldr_p.name = "apertureLength_sldr"; 

        this.AFDwidth_sldr_p = this.getProxy(
        "controls.AFDwidth_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.AFDwidth_sldr_p.trackLength = 200;
        this.AFDwidth_sldr_p.tickInterval = 100;
        this.AFDwidth_sldr_p.minimum = 10;
        this.AFDwidth_sldr_p.maximum = 2000;
        this.AFDwidth_sldr_p.snapInterval = 1; // Set this before setting value
        this.AFDwidth_sldr_p.value = 200;
        this.AFDwidth_sldr_p.enabled = true;
        this.AFDwidth_sldr_p.enableWheel = false;
        this.AFDwidth_sldr_p.name = "AFDwidth_sldr"; 

        this.AFDlength_sldr_p = this.getProxy(
        "controls.AFDlength_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.AFDlength_sldr_p.trackLength = 200;
        this.AFDlength_sldr_p.tickInterval = 50;
        this.AFDlength_sldr_p.minimum = 10;
        this.AFDlength_sldr_p.maximum = 2000;
        this.AFDlength_sldr_p.snapInterval = 1; // Set this before setting value
        this.AFDlength_sldr_p.value = 200;
        this.AFDlength_sldr_p.enabled = true;
        this.AFDlength_sldr_p.enableWheel = false;
        this.AFDlength_sldr_p.name = "AFDlength_sldr"; 

        this.AFDtaper_sldr_p = this.getProxy(
        "controls.AFDtaper_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.AFDtaper_sldr_p.trackLength = 200;
        this.AFDtaper_sldr_p.tickInterval = 5;
        this.AFDtaper_sldr_p.minimum = 10;
        this.AFDtaper_sldr_p.maximum = 1000;
        this.AFDtaper_sldr_p.snapInterval = .5; // Set this before setting value
        this.AFDtaper_sldr_p.value = 100;
        this.AFDtaper_sldr_p.enabled = true;
        this.AFDtaper_sldr_p.enableWheel = false;
        this.AFDtaper_sldr_p.name = "AFDtaper_sldr";         

        this.phaseX_sldr_p = this.getProxy(
        "controls.phaseX_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.phaseX_sldr_p.trackLength = 200;
        this.phaseX_sldr_p.tickInterval = 10;
        this.phaseX_sldr_p.minimum = -90;
        this.phaseX_sldr_p.maximum = 90;
        this.phaseX_sldr_p.snapInterval = .5; // Set this before setting value
        this.phaseX_sldr_p.value = 0;
        this.phaseX_sldr_p.enabled = true;
        this.phaseX_sldr_p.enableWheel = false;
        this.phaseX_sldr_p.name = "phaseX_sldr"; 

        this.phaseY_sldr_p = this.getProxy(
        "controls.phaseY_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.phaseY_sldr_p.trackLength = 200;
        this.phaseY_sldr_p.tickInterval = 10;
        this.phaseY_sldr_p.minimum = -90;
        this.phaseY_sldr_p.maximum = 90;
        this.phaseY_sldr_p.snapInterval = .5; // Set this before setting value
        this.phaseY_sldr_p.value = 0;
        this.phaseY_sldr_p.enabled = true;
        this.phaseY_sldr_p.enableWheel = false;
        this.phaseY_sldr_p.name = "phaseY_sldr"; 

        this.analysisSpan_sldr_p = this.getProxy(
        "controls.analysisSpan_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.analysisSpan_sldr_p.trackLength = 200;
        this.analysisSpan_sldr_p.tickInterval = 100;
        this.analysisSpan_sldr_p.minimum = 50;
        this.analysisSpan_sldr_p.maximum = 2000;
        this.analysisSpan_sldr_p.snapInterval = 1; // Set this before setting value
        this.analysisSpan_sldr_p.value = 2000;
        this.analysisSpan_sldr_p.enabled = true;
        this.analysisSpan_sldr_p.enableWheel = false;
        this.analysisSpan_sldr_p.name = "analysisSpan_sldr"; 

        this.nPts_sldr_p = this.getProxy(
        "controls.nPts_sldr",  // stage symbol instance name (display tree path)
        Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.nPts_sldr_p.trackLength = 200;
        this.nPts_sldr_p.tickInterval = 128;
        this.nPts_sldr_p.minimum = 128;
        this.nPts_sldr_p.maximum = 256;
        this.nPts_sldr_p.snapInterval = 128; // Set this before setting value
        this.nPts_sldr_p.value = 128;
        this.nPts_sldr_p.enabled = true;
        this.nPts_sldr_p.enableWheel = false;
        this.nPts_sldr_p.name = "nPts_sldr"; 
    }
    private configureDials(){
        this.cutDial_p = this.getProxy(
        "cut.cutDial",  // stage symbol instance name (display tree path)
        Dial_p,   // Class of the proxy to be created
        {animateSpace:this.animateSpace}); // Extra data (not used)
        this.cutDial_p.quickInit2(0, -180, -180, 180, 180, 360, 0, 0, false); // val, valmin, minsnug, maxsnug, max, scale, angzero, valzero, hasindicators
        this.cutDial_p.snap = false; // Turns on snapping.  Default is false.
        this.cutDial_p.name = "cutDial";
        this.stageSymbol.cut.cutDial_txt.text = "Cut angle";

    }
    private configureCheckBoxes(){
           this.cutEnable_cb_p = this.getProxy(
            "controls.cutEnable_cb",  // stage symbol instance name (display tree path)
            Checkbox_p,   // Class of the proxy to be created
            {animateSpace:this.animateSpace}); // Extra data (not used)
    
            this.cutEnable_cb_p.name = "cutEnable_cb";
            this.cutEnable_cb_p.labelSide = "right";
            this.cutEnable_cb_p.selected = false;
            this.cutEnable_cb_p.labelText = "Show cut";
            this.cutEnable_cb_p.labelFont = "20px Arial";
            this.cutEnable_cb_p.labelColor = "black";
            this.cutEnable_cb_p.fillColor = "white";
    }

    public positionPanels(sw:number, sh:number, px:number, py:number, pweach:number, pxspacing:number, ph:number){

        this._anStageWidth = sw;
        this._anStageHt = sh; 
        this._panelX = px; 
        this._panelY = py; 
        this._panelWidthEach = pweach; 
        this._panelXspacing = pxspacing; 
        this._panelHeight = ph;

        // First 3D renderspace:
        this.universal_rs1.setBoundsBaseObject(this.animateSpace.getCanvas());
        this.universal_rs2.setBoundsBaseObject(this.animateSpace.getCanvas());

        // Second 3D renderspace:
        this.universal_rs1.setBounds(this._panelX/this._anStageWidth, this._panelY/this._anStageHt, 
            this._panelWidthEach/this._anStageWidth, this._panelHeight/this._anStageHt);        

        this.universal_rs2.setBounds((this._panelX+this._panelWidthEach+this._panelXspacing)/this._anStageWidth, this._panelY/this._anStageHt, 
            this._panelWidthEach/this._anStageWidth, this._panelHeight/this._anStageHt);
    }

    public recalc3Dsurfaces(){
        this.recalcSpatialDomain();
        this.recalcFrequencyDomain();
        this.redraw3D();
        //this.updateTexts();
    }
    public recalcSpatialDomain(){
        //Loads AFD_Function (v1)
        let i:number;
        let j:number;
        let AFD:Array<Array<Complex>> = [];
        let xx:number;
        let yy:number;
        let aa:number;
        let ab:number;
        let ac:number;
        let ia:number;
        let ib:number;
        let r:number;
        let ye:number;
        let ya:number;
       
        AFD = [];

        this._ds = this.analysisSpan/this.Npts;

        ia = this.AFD_Width/2;
        ib = this.AFD_Length/2;
        aa = this.apertureWidth/2;
        ab = this.apertureLength/2;
        ac = Math.sqrt(aa*aa + ab*ab);

        for (i=0; i<this.Npts; i++){
            AFD[i] = [];
            for (j=0; j<this.Npts; j++){

                xx = this.i2d(i);
                yy = this.i2d(j);
                r = Math.sqrt(xx*xx + yy*yy);

                let thetaX = UtilSP.radians(this.phasePointingX); // Pointing angle
                let ex = xx * Math.sin(thetaX);
                let phix = (ex/this.lambda)*2*Math.PI;

                let thetaY = UtilSP.radians(this.phasePointingY); // Pointing angle
                let ey = yy * Math.sin(thetaY);
                let phiy = (ey/this.lambda)*2*Math.PI;

                let phi:number = phix + phiy;
                let phaseNetDeg = UtilSP.degrees(phi);
                let mag:number;
                //console.log("xx = "+xx+", yy = "+yy+",  r = "+r+", phaseNetdeg = "+phaseNetdeg);

                if (this.taperType == "Flat"){
                    if (this.AFD_Shape == "Rectangular" || this.AFD_Shape == "Square"){
                        // Flat Rectangular AFD function
                        if ( (xx < -ia) || (xx>ia) || (yy <-ib) || (yy>ib) ){
                            AFD[i][j] = new Complex( 0, 0);
                        } else {
                            AFD[i][j] = new Complex( this._magMax*Math.cos(phi), this._magMax*Math.sin(phi));
                        }
                    } else if (this.AFD_Shape == "Elliptical" || this.AFD_Shape == "Circular"){
                        // Flat Elliptical AFD_ function
                        ye = ib * Math.sqrt(1 - (xx*xx)/(ia*ia));
                        if ( Math.abs(yy) <= ye){
                            AFD[i][j] = new Complex( this._magMax*Math.cos(phi), this._magMax*Math.sin(phi));
                        } else {
                            AFD[i][j] = new Complex( 0, 0);
                        }
                    } else {
                        console.log("ERROR in recalcSpatialDomain(): invalid AFD_Shape "+this.AFD_Shape);
                    }
                } else if (this.taperType == "Gaussian"){
                    // Gaussian Elliptical
                    let w = this.AFD_GaussianTaper/2;                    
                    mag = this._magMax*Math.exp( -r*r / (w*w));
                    AFD[i][j] = new Complex( mag*Math.cos(phi), mag*Math.sin(phi));                
                }
                // Now apply the aperture window
                if (this.apertureShape == "Rectangular" || this.apertureShape == "Square"){
                    // Rectangular aperture
                    if ( (xx < -aa) || (xx>aa) || (yy <-ab) || (yy>ab) ){
                        // Zero out whatever the AFD_ function is if we are outside this rectnagle.
                        AFD[i][j] = new Complex( 0, 0);
                    }
                } else if (this.apertureShape == "Elliptical" || this.apertureShape == "Circular"){
                    // Elliptical aperture
                    ya = ab * Math.sqrt(1 - (xx*xx)/(aa*aa));
                    if ( Math.abs(yy) > ya || Math.abs(xx)>aa){
                        // Zero out whatever the AFD_ function is if we are outside this ellipse.
                        AFD[i][j] = new Complex( 0, 0);
                    }                    
                } else {
                    console.log("ERROR in recalcSpatialDomain(): invalid apertureShape "+this.apertureShape);
                }
                //console.log("i = "+i+", xx = "+xx+", j = "+j+", yy = "+yy+", AFD_ = "+AFD_[i][j].re)
            }
        }   

		this.v1 = [];
        for (i=0; i<this.Npts; i++){
			this.v1[i] = [];
        	for (j=0; j<this.Npts; j++){
				this.v1[i][j] = AFD[i][j].clone(); // No scaling
            }
        }

        // Load the values arrays ready to be plotted.
        this.AFD_Xvalues = [];
        this.AFD_Yvalues = [];
        this.AFD_Zvalues = [];
        this.AFD_XYZvalues = [];
        for (i=0; i<this.Npts; i++){
            this.AFD_XYZvalues[i] = [];
            for (j=0; j<this.Npts; j++){
                this.AFD_XYZvalues[i][j] = {};
            }
        }

        let xTemp:number;
        let yTemp:number;
        let zTemp:number;
        let rTemp:number;
        let thetaTemp:number;
        let thetaNew:number;
        for (i=0; i<this.Npts; i++){
            for (j=0; j<this.Npts; j++){
                // These are the points as laid out without rotating the AFD_ function.
                xTemp = this.i2d(i);
                yTemp = this.i2d(j); 
                zTemp = 1*this.v1[i][j].mag;
                // Now rotate them around the Z axis. THIS DOESN"T WORK.
                rTemp = Math.sqrt(xTemp*xTemp + yTemp*yTemp);
                thetaTemp =  Math.atan2(yTemp, xTemp);
                thetaNew = thetaTemp; //  + UtilSP.radians(this._AFD_Rotation);   Doesn't work
                this.AFD_XYZvalues[i][j].x = rTemp*Math.cos(thetaNew);
                this.AFD_XYZvalues[i][j].y = rTemp*Math.sin(thetaNew);
                this.AFD_XYZvalues[i][j].z = zTemp;
            }
        }

    } 
    public recalcFrequencyDomain(){
        // Assumes v1 has been set by set
        // See googledoc "Antenna patterns from aperture distributions (AFD_ functions)"

        this._ks = 2*Math.PI/(this.Npts * this._ds);

        let i:number;
        let j:number;

        let v2:Array<Array<Complex>>;
        let v3:Array<Array<Complex>>;
        let v4:Array<Array<Complex>>;
        v2 = [];
        v3 = [];
        v4 = [];
        for (i=0; i<this.Npts; i++){
            v2[i] = [];
            v3[i] = [];
            v4[i] = [];
        }

        // Horizontal FFT:
        for (j=0; j<this.Npts; j++){
            v2[j] =  SigProc.fft(this.v1[j]);
        }
        //Swap cut to vertical:
        for (i=0; i<this.Npts; i++){
            for (j=0; j<this.Npts; j++){
                v3[i][j] = v2[j][i].clone();
            }
        }
        // Vertical FFT:
        for (i=0; i<this.Npts; i++){
            v4[i] =  SigProc.fft(v3[i]);
        }  

        this.patternAlphaValues = [];
        this.patternBetaValues = [];
        this.patternZvalues = [];
        let alphaDeg:number;
        let betaDeg:number;
        let patternZUnswapped:Array<Array<number>> = [];
        this.patternXYZvalues = [];

        let kx:number; // spatial frequency in x axis
        let ky:number; // spatial frequency in y axis

        for (let i=0; i<this.Npts; i++){
            patternZUnswapped[i] = [];
            this.patternXYZvalues[i] = [];
            for (let j=0; j<this.Npts; j++){
                //kx = this.i2k(j);
                //ky = this.i2k(i);
                kx = this.i2k(i);
                ky = this.i2k(j);
                alphaDeg = UtilSP.degrees( Math.asin( kx * this.lambda / (-2*Math.PI)) );
                betaDeg = UtilSP.degrees( Math.asin( ky * this.lambda / (-2*Math.PI)) );
                this.patternAlphaValues[i] = alphaDeg;
                this.patternBetaValues[j] = betaDeg;                
                this.patternXYZvalues[i][j] = {};
                this.patternXYZvalues[i][j].x = alphaDeg; // x
                this.patternXYZvalues[i][j].y = betaDeg; // y
                patternZUnswapped[i][j] = 1*v4[i][j].magdB + 0; // Scaling goes here. Don't store it yet - we need to swap it first.
                //console.log("i = "+i+", j = "+j+", alphaDeg = "+alphaDeg+", betaDeg = "+betaDeg);
            }
        }        
        // Swap to center
        this.patternZvalues = this.swapOrder(patternZUnswapped);   
        for (let i=0; i<this.Npts; i++){
            for (let j=0; j<this.Npts; j++){
                this.patternXYZvalues[i][j].z = this.patternZvalues[i][j];
                //console.log("XYZvalues: i = "+i+", j = "+j+", x = "+this.patternXYZvalues[i][j].x+", y = "+this.patternXYZvalues[i][j].y+
                //    ", z = "+this.patternXYZvalues[i][j].z);
            }
        }         
    }
	public redraw3D(){

        //----------------------------------------------------
        //console.log("in redraw3D()");
        /* Redraws 
            AFD_XYZvalues
            patternZvalues, patternAlphaValues, patternBetaValues
        */

        this.patternTop_g = new XY3DSurface3_geom(this.patternXYZvalues, true );
        this.patternTop_mat = new THREE.MeshPhongMaterial({color:UtilSP.c2rgba("yellow"), transparent:true, opacity:1});
        this.patternTop_m.geometry = this.patternTop_g;
        this.patternTop_m.material = this.patternTop_mat;
        this.patternTop_m.rotation.x = -Math.PI/2;

        this.patternBot_g = new XY3DSurface3_geom(this.patternXYZvalues, false );
        this.patternBot_mat = new THREE.MeshPhongMaterial({color:UtilSP.c2rgba("gray"), transparent:true, opacity:1});
        this.patternBot_m.geometry = this.patternBot_g
		this.patternBot_m.material = this.patternBot_mat;
        this.patternBot_m.rotation.x = -Math.PI/2;
        this.universal_rs2.uniCamHandler.lookat = new THREE.Vector3(0,this._lookatY,0);

        // AFD_ function:
		this.AFD_Base_g = new THREE.PlaneGeometry(this.analysisSpan, this.analysisSpan); /// wrong!
        this.AFD_Base_mat = new THREE.MeshBasicMaterial({color:0x000000});
		this.AFD_Base_m.geometry = this.AFD_Base_g;
        this.AFD_Base_m.material = this.AFD_Base_mat;
        this.AFD_Base_m.position.y = 1;
        this.AFD_Base_m.rotation.x = -Math.PI/2;

        this.aperture_mat = new THREE.MeshBasicMaterial({color:0xFF0000});
        this.aperture_m.material = this.aperture_mat;
        if (this.apertureShape == "Rectangular" || this.apertureShape == "Square"){
		    this.aperture_g = new THREE.PlaneGeometry(this.apertureWidth, this.apertureLength); /// wrong!
		    this.aperture_m.geometry = this.aperture_g;
            this.aperture_m.scale.set(1,1,1);
        } else {
            // Circular or elliptical
		    this.aperture_g = new THREE.CircleGeometry(1,32);
		    this.aperture_m.geometry = this.aperture_g;
            this.aperture_m.scale.set(this.apertureWidth/2,this.apertureLength/2,1);
        }
        this.aperture_m.position.y = 2;
        this.aperture_m.rotation.x = -Math.PI/2; 
        this.aperture_m.rotation.z = Math.PI/2;  // Force 90 deg rotation to match pattern orientation

        this.AFD_Top_g = new XY3DSurface3_geom(this.AFD_XYZvalues, true );
        this.AFD_Top_mat = new THREE.MeshPhongMaterial({color:UtilSP.c2rgba("yellow"), transparent:true, opacity:1});
        this.AFD_Top_m.geometry = this.AFD_Top_g
		this.AFD_Top_m.material = this.AFD_Top_mat;
        this.AFD_Top_m.rotation.x = -Math.PI/2;
        this.AFD_Top_m.rotation.z = Math.PI/2;  // Force 90 deg rotation to match pattern orientation

        this.AFD_Bot_g = new XY3DSurface3_geom(this.AFD_XYZvalues, false );
        this.AFD_Bot_mat = new THREE.MeshPhongMaterial({color:UtilSP.c2rgba("gray"), transparent:true, opacity:1});
        this.AFD_Bot_m.geometry = this.AFD_Bot_g;
        this.AFD_Bot_m.material = this.AFD_Bot_mat;
        this.AFD_Bot_m.rotation.x = -Math.PI/2;
        this.AFD_Bot_m.rotation.z = Math.PI/2;  // Force 90 deg rotation to match pattern orientation

        this.updateCut();

        this.universal_rs1.uniCamHandler.lookat = new THREE.Vector3(0,0,0);
    } 
	 
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame
        //this. updateTexts();
        if (this._syncPanelViews){
            if (this.universal_rs1.uniCamHandler.mouseIsDown){
                //this.universal_rs2.uniCamHandler.tilt = this.universal_rs1.uniCamHandler.tilt;
                //this.universal_rs2.uniCamHandler.pan = this.universal_rs1.uniCamHandler.pan;
                this.syncPanel2ViewtoPanel1();
            }
            if (this.universal_rs2.uniCamHandler.mouseIsDown){
                //this.universal_rs1.uniCamHandler.tilt = this.universal_rs2.uniCamHandler.tilt;
                //this.universal_rs1.uniCamHandler.pan = this.universal_rs2.uniCamHandler.pan;
                this.syncPanel1ViewtoPanel2();
            } 
            if (this.universal_rs1.uniCamHandler.currentlyTweening){
                this.syncPanel2ViewtoPanel1();
            }

        }
	} 
    public syncPanel2ViewtoPanel1(){
        //this.universal_rs2.uniCamHandler.tilt = this.universal_rs1.uniCamHandler.tilt;
        //this.universal_rs2.uniCamHandler.pan = this.universal_rs1.uniCamHandler.pan; 
        this.universal_rs2.uniCamHandler.snapTo(this.universal_rs1.uniCamHandler.pan, this.universal_rs1.uniCamHandler.tilt);
    }    
    public syncPanel1ViewtoPanel2(){
        this.universal_rs1.uniCamHandler.snapTo(this.universal_rs2.uniCamHandler.pan, this.universal_rs2.uniCamHandler.tilt);
    }    
    private swapOrder(v:Array<Array<number>>):Array<Array<number>>{
        let Ni:number = v.length;
        let Nj:number = v[0].length;
        let vswap:Array<Array<number>>;
        vswap = [];
        for (let i:number=0; i<Ni; i++){
            vswap[i] = [];
        }
        let newi:number;
        let newj:number;

        for (let i:number=0; i<Ni; i++){
            for (let j:number=0; j<Nj; j++){
                if (i<Ni/2 && j<Nj/2){
                    newi = i+Ni/2;
                    newj = j+Nj/2;
                    //vswap[i+Ni/2][j+Nj/2] = v[i][j].clone(); // Quadrant 1 -> 4
                } else if (i>=Ni/2 && j<Nj/2) {
                    newi = i-Ni/2;
                    newj = j+Nj/2;                
                    //vswap[i-Ni/2][j+Nj/2] = v[i][j].clone(); // Quadrant 2 -> 3
                } else if (i<Ni/2 && j>=j/2){
                    newi = i+Ni/2;
                    newj = j-Nj/2;    /////             
                    //vswap[i+Ni/2][j-Nj/2] = v[i][j].clone(); // Quadrant 3 -> 2                    
                } else if (i>=Ni/2 && j>=j/2){
                    //vswap[i-Ni/2][j-Nj/2] = v[i][j].clone(); // Quadrant 4 -> 1    
                    newi = i-Ni/2;
                    newj = j-Nj/2;  
                } else{
                    console.log("ERROR in swapOrder: invalid i = "+i+" or j = "+j);
                }
                //console.log("i = "+i+", j = "+j+", newi = "+newi+", newj = "+newj);
                vswap[newi][newj] = v[i][j]; 
            }
        }
        return vswap;
    }

    private generateScales(){
        let patternNumAngleDivs:number = 16;
        let patternGainMax:number = 50;
        let patternGainDivs:number = 10;

        let patternGainMin = patternGainMax - patternGainDivs*this._patternGaindBPerDiv;
        let patternDegMin = -this._patternDegPerDiv * (patternNumAngleDivs/2);
        let patternDegMax = -patternDegMin;

        let AFD_MagMin:number = 0;
        let AFD_MagDivs:number = 10;
        let AFD_MagMax:number = AFD_MagMin + AFD_MagDivs*this._AFD_MagPerDiv;

        let AFD_Ddivs:number = 10;
        let AFD_Dmax:number = 1000;
        let AFD_Dmin:number = -1000;

        let XscaleLineColor:string = "#806161"; //"lightgray";
        let YscaleLineColor:string = "#868f9e"; //"lightgray";
        let scaleLineWidth:number = 2;
        let scaleLineMat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial( { color: "lightgray"} );
        let blacklineMat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial( { color: 0x000000} );
        let greenlineMat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial( { color: 0x00FF00} );
        let bluelineMat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial( { color: 0x0000FF} );
        let redlineMat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial( { color: 0xFF0000} );
        let i:number;
        let AFD_Zmin:number = -50;


        //Vertical scale line on the AFD_ plot
        let iMid1:number = AFD_Ddivs/2;
        let AFD_Xline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=AFD_Ddivs; i++){
            AFD_Xline_pl[i] = new PolyLine_grp();
            AFD_Xline_pl[i].quickSet((i-iMid1)*this._AFD_DperDiv, AFD_MagMin, 0,  
                (i-iMid1)*this._AFD_DperDiv, AFD_MagMax, 0,  
                XscaleLineColor, scaleLineWidth);
            if (i== iMid1){
                // axes are already there
            } else {
                this.AFD_Scales.add(AFD_Xline_pl[i]);
            }
        }


        let AFD_Yline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=AFD_Ddivs; i++){
            AFD_Yline_pl[i] = new PolyLine_grp();
            AFD_Yline_pl[i].quickSet(0, AFD_MagMin, (i-iMid1)*this._AFD_DperDiv,  
                0, AFD_MagMax, (i-iMid1)*this._AFD_DperDiv,  
                YscaleLineColor, scaleLineWidth);            
            if (i== iMid1){
                // axes are already there
            } else {
                this.AFD_Scales.add(AFD_Yline_pl[i]);
            }
        } 

        let AFD_XHline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternGainDivs; i++){
            AFD_XHline_pl[i] = new PolyLine_grp();
            AFD_XHline_pl[i].quickSet(
                AFD_Dmin, AFD_MagMin + i*this._AFD_MagPerDiv, 0,  
                AFD_Dmax, AFD_MagMin + i*this._AFD_MagPerDiv, 0,  
                XscaleLineColor, scaleLineWidth);             
            this.AFD_Scales.add(AFD_XHline_pl[i]);
        }

        let AFD_YHline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternGainDivs; i++){
            AFD_YHline_pl[i] = new PolyLine_grp();
            AFD_YHline_pl[i].quickSet(
                0, AFD_MagMin + i*this._AFD_MagPerDiv, AFD_Dmin,  
                0, AFD_MagMin + i*this._AFD_MagPerDiv, AFD_Dmax,  
                YscaleLineColor, scaleLineWidth);             
                this.AFD_Scales.add(AFD_YHline_pl[i]);
        }



        // Vertical scale lines on the pattern plot
        let iMid2:number = patternNumAngleDivs/2;        
        let patternXVline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternNumAngleDivs; i++){

            patternXVline_pl[i] = new PolyLine_grp();
            patternXVline_pl[i].quickSet(
                (i-iMid2)*this._patternDegPerDiv, patternGainMin, 0, 
                (i-iMid2)*this._patternDegPerDiv, patternGainMax, 0,  
                XscaleLineColor, scaleLineWidth);               
            if (i== iMid2){
                //AFD_Xline_l[i] = new THREE.Line(AFD_Xline_g[i], greenlineMat);
                // axes are already there
            } else {
                //patternXVline_l[i] = new THREE.Line(patternXVline_g[i], scaleLineMat);
                this.patternScales.add(patternXVline_pl[i]);
            }
        }

        let patternYVline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternNumAngleDivs; i++){

            patternYVline_pl[i] = new PolyLine_grp();
            patternYVline_pl[i].quickSet(
                0, patternGainMin, (i-iMid2)*this._patternDegPerDiv, 
                0, patternGainMax, (i-iMid2)*this._patternDegPerDiv,  
                YscaleLineColor, scaleLineWidth);                
            if (i== iMid2){
                // axes are already there
            } else {
                this.patternScales.add(patternYVline_pl[i]);
            }
        }                       

        // Horizontal scale lines on the pattern plot
        let patternXHline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternGainDivs; i++){
            patternXHline_pl[i] = new PolyLine_grp();
            patternXHline_pl[i].quickSet(
                patternDegMin, patternGainMax - i*this._patternGaindBPerDiv, 0, 
                patternDegMax, patternGainMax - i*this._patternGaindBPerDiv, 0,  
                XscaleLineColor, scaleLineWidth);               
                this.patternScales.add(patternXHline_pl[i]);
        }

        let patternYHline_pl:Array<PolyLine_grp> = [];
        for (i=0; i<=patternGainDivs; i++){
            patternYHline_pl[i] = new PolyLine_grp();
            patternYHline_pl[i].quickSet(
                0, patternGainMax - i*this._patternGaindBPerDiv, patternDegMin, 
                0, patternGainMax - i*this._patternGaindBPerDiv, patternDegMax,  
                YscaleLineColor, scaleLineWidth);              
            this.patternScales.add(patternYHline_pl[i]);
        }
    
    }
    private computeCut(){
        let cosTheta = Math.cos(UtilSP.radians(this.cutTheta));
        let sinTheta = Math.sin(UtilSP.radians(this.cutTheta));
        let m:number;
        let cutAlpha:Array<number>;
        let cutBeta:Array<number>;
        let cuti:number;
        let cutj:number;
        let cutSpacing:number = this._cutSpan/this._cutNpoints;
        let rAlpha:number;
        let rBeta:number;
        let v1:number;
        let v2:number;
        let vInterp:number;
        this._cutX = [];
        this._cutValues = [];
        cutAlpha = [];
        cutBeta = [];
        let cutLine_p:Array<THREE.Vector3> = []; // Array of points

        let cutCenterAlpha = this.cutCenterOffset*cosTheta;
        let cutCenterBeta = this.cutCenterOffset*sinTheta;
        //console.log("Cutline:");
        for (m=0; m<this._cutNpoints; m++){
            this._cutX[m] = -this._cutSpan/2 + cutSpacing * m; // X axis of the cut pattern plot
            // Off-axis cartesian angles to each cut point
            cutAlpha[m] = cutCenterAlpha + this._cutX[m] * sinTheta
            cutBeta[m] = cutCenterBeta + this._cutX[m] * cosTheta
            cuti = this.alpha2i(cutAlpha[m]);
            cutj = this.beta2j(cutBeta[m]);
            if (cuti <0 || cutj < 0 || cuti >= this.patternAlphaValues.length-1 || cutj >= this.patternBetaValues.length-1){
                console.log("ERROR in AntennaPatternFourierSimulator_p.computeCut: cuti or cutj out of range.");
                //debugger
            }

            rAlpha = (cutAlpha[m] - this.patternAlphaValues[cuti])/(this.patternAlphaValues[cuti+1] - this.patternAlphaValues[cuti]);
            rBeta = (cutBeta[m] - this.patternBetaValues[cutj])/(this.patternBetaValues[cutj+1] - this.patternBetaValues[cutj]);
            v1 = this.patternZvalues[cuti][cutj] + rAlpha*(this.patternZvalues[cuti+1][cutj]-this.patternZvalues[cuti][cutj]);
            v2 = this.patternZvalues[cuti][cutj+1] + rAlpha*(this.patternZvalues[cuti+1][cutj+1]-this.patternZvalues[cuti][cutj+1]);
            vInterp = v1 + rBeta*(v2-v1);

            this._cutValues[m] = 0.1 + vInterp; ///this.patternZvalues[cuti][cutj]; // Future - interpolate instead of taking nearest m
            cutLine_p.push( new THREE.Vector3(cutAlpha[m], this._cutValues[m], cutBeta[m] )); 
        }

        //this.patternCutLine_pl.clearAll();
        this.patternCutLine_pl.points = cutLine_p;
        this.patternCutLine_pl.lineColor = "red";
        this.patternCutLine_pl.lineWidth = 3;
        //this.patternCutLine_pl.rebuild();


    }
    private alpha2i(alpha:number){
        // Find index i such that alpha is between patternAlphaValues[i] and patternAlphaValues[i+1]
        // Returns 0 if it can't find a result
        let i:number;
        let iResult:number = -1;
        for (i=0; i<this.Npts-1; i++){
            if ( 
                (alpha >= this.patternAlphaValues[i] && alpha < this.patternAlphaValues[i+1])
                    ||
                (alpha > this.patternAlphaValues[i+1] && alpha <= this.patternAlphaValues[i]) ){
                    iResult = i
                }
        }
        if (iResult == -1){
            return 0; // If not found, just return the first alpha
        }  else {
            return iResult;
        }
    }
    private beta2j(beta:number){
         // Find index j such that beta is between patternBetaValues[i] and patternBetaValues[i+1]
        // Returns 0 if it can't find a result
        let j:number;
        let jResult:number = -1;
        for (j=0; j<this.Npts; j++){
            if ( 
                (beta >= this.patternBetaValues[j] && beta < this.patternBetaValues[j+1])
                    ||
                (beta > this.patternBetaValues[j+1] && beta <= this.patternBetaValues[j]) ){
                    jResult = j
                }
                //console.log("j = "+j+", val[j] = "+this.patternBetaValues[j]+", val[j+1]= "+
                //    this.patternBetaValues[j+1])
        }
        //console.log("In beta2j, beta = "+beta+", j = "+j);
        //console.log("patternBetaValues = ",this.patternBetaValues);
        if (jResult == -1){
            return 0; // If not found, just return the first beta
        }  else {
            return jResult;
        }
    }
    public i2d(i:number):number{
        return this._ds*(i - this.Npts/2);
    } 
    public i2k(i:number):number{
        return this._ks*(i - this.Npts/2);
    }  
    public get leftSideDetails():string{
        let str1:string = "";
        str1 += "Legend:";
        str1 += "\n    Black: Analysis area";
        str1 += "\n    Red: Antenna aperture (limits of the reflector or array panel)";
        str1 += "\n    Yellow: Aperture Field Distribution (AFD) function";
        str1 += "\n";
        str1 += "Vertical scale: "+this.AFD_MagPerDiv+" units/div";
        str1 += "\n";
        str1 += "Horizontal scale: "+this._AFD_DperDiv+" mm/div";

        str1 += "\n";
        return str1;
    }  

    public get rightSideDetails():string{
        let str1:string = "";
        //str1 += "Camera distance = "+this.universal_rs1.uniCamHandler.distance.toFixed(0);
       // str1 += "\n";
        str1 += "Far-field pattern magnitude (dB)";
        str1 += "\n    Vertical scale: "+this.patternGaindBPerDiv+" dB/div";
        str1 += "\n    Horizontal scale: "+this.patternDegPerDiv+" deg/div";

        return str1;
    }  
    public get cameraSummary():string{
        let str1:string = "";
        str1 += "\n";
        str1 += "LEFT: Camera dist/pan/tilt = "+this.universal_rs1.uniCamHandler.distance.toFixed(0); 
        str1 += " / "+this.universal_rs1.uniCamHandler.pan.toFixed(0); 
        str1 += " /"+this.universal_rs1.uniCamHandler.tilt.toFixed(0);    
        str1 += "\n";
        str1 += "RIGHT: Camera dist/pan/tilt/lookatY = "+this.universal_rs2.uniCamHandler.distance.toFixed(0); 
        str1 += " / "+this.universal_rs2.uniCamHandler.pan.toFixed(0); 
        str1 += " /"+this.universal_rs2.uniCamHandler.tilt.toFixed(0); 
        str1 += " /"+this._lookatY.toFixed(1); 
        return str1;
    }
    private updateLayout(){
        this.stageSymbol.leftSideDetails_txt.y = 655;
        this.stageSymbol.rightSideDetails_txt.y = 655;
        this.updateCut();
        switch (this._layout){
            // "none"; // Hides the whole renderspace
            // "block"; // Reveals the whole renderspace
            //  anStageWidth, anStageHt, panelX, panelY, panelWidthEach, panelXspacing, panelHeight
            case "Full":
                this.positionPanels(this._stageWidth, this._stageHeight, 450, 100, 600, 50, 600);
                this.universal_rs1.getCanvas().style.display="block";
                this.universal_rs2.getCanvas().style.display="block";
                this.showControls = true;
                this.showCut = true;
                this.stageSymbol.leftSideDetails_txt.visible = true;
                this.stageSymbol.rightSideDetails_txt.visible = true;
                this.stageSymbol.leftSideDetails_txt.x = 318;
                this.stageSymbol.rightSideDetails_txt.x = 993;
                break;
            case "Pattern only":
                this.positionPanels(this._stageWidth, this._stageHeight, 500, 50, 900, 50, 900);
                this.universal_rs1.getCanvas().style.display="none";
                this.universal_rs2.getCanvas().style.display="block";                
                this.showControls = false;
                this.showCut = false;
                this.stageSymbol.leftSideDetails_txt.visible = false;
                this.stageSymbol.rightSideDetails_txt.visible = this._showRightSideDetails;
                this.stageSymbol.rightSideDetails_txt.x = 1650;
                this.stageSymbol.rightSideDetails_txt.y = 930;
                break;
            case "Pattern and cut":
                this.positionPanels(this._stageWidth, this._stageHeight, 450, 100, 600, 50, 600);
                this.universal_rs1.getCanvas().style.display="none";
                this.universal_rs2.getCanvas().style.display="block";                
                this.showControls = false;
                this.showCut = true;
                this.stageSymbol.leftSideDetails_txt.visible = false;
                this.stageSymbol.rightSideDetails_txt.visible = this._showRightSideDetails;                
                this.stageSymbol.rightSideDetails_txt.x = 993;
                break;                
            case "AFD and pattern only":
                this.positionPanels(this._stageWidth, this._stageHeight, 1100, 100, 600, 50, 600);
                this.universal_rs1.getCanvas().style.display="block";
                this.universal_rs2.getCanvas().style.display="block";                
                this.showControls = false;
                this.showCut = false;
                this.stageSymbol.leftSideDetails_txt.visible = this._showLeftSideDetails;
                this.stageSymbol.rightSideDetails_txt.visible = this._showRightSideDetails;  
                this.stageSymbol.leftSideDetails_txt.x = 993;
                this.stageSymbol.rightSideDetails_txt.x = 1650;                              
                break;   
            case "AFD only":
                //  anStageWidth, anStageHt, panelX, panelY, panelWidthEach, panelXspacing, panelHeight
                this.positionPanels(this._stageWidth, this._stageHeight, 1400, 50, 900, 50, 900);
                this.universal_rs1.getCanvas().style.display="block";
                this.universal_rs2.getCanvas().style.display="none";                
                this.showControls = false;
                this.showCut = false;
                this.stageSymbol.leftSideDetails_txt.visible = this._showLeftSideDetails;
                this.stageSymbol.rightSideDetails_txt.visible = false;                   
                this.stageSymbol.leftSideDetails_txt.x = 1650;
                break;
            case "Invisible":
                this.universal_rs1.getCanvas().style.display="none";
                this.universal_rs2.getCanvas().style.display="none";
                this.showControls = false;
                this.showCut = false;
                this.stageSymbol.leftSideDetails_txt.visible = false;
                this.stageSymbol.rightSideDetails_txt.visible = false;
                break;  
            default:
                console.log("ERROR in updateLayout: invalid _layout = "+this._layout);
                break;    
        }
    
    }
    // ------------- Getters and setters
    public set layout(val:string){
        this._layout = val;
        this.updateLayout();
    }
    public get layout(){
        return this._layout;
    }
    public set apertureShape(val:string){
        switch (val){
            case "Circular":
                this.apertureShape_rb_p.selected = 0;
                break;
            case "Elliptical":
                this.apertureShape_rb_p.selected = 1;
                break;
            case "Square":
                this.apertureShape_rb_p.selected = 2;
                break;
            case "Rectangular":
                this.apertureShape_rb_p.selected = 3;
                break;                        
        }
        this.update();
    }  
    public get apertureShape(){
        switch (this.apertureShape_rb_p.selected){
            case 0:
                return "Circular";
                break;
            case 1:
                return "Elliptical";
                break;
            case 2:
                return "Square";
                break;
            case 3:
                return "Rectangular";
                break;                
        }   
    } 
    public set taperType(val:string){
        switch (val){
            case "Gaussian":
                this.taperType_rb_p.selected = 0;
                break;
            case "Flat":
                this.taperType_rb_p.selected = 1;
                break;                       
        }
        this.update();
    }  
    public get taperType(){
        switch (this.taperType_rb_p.selected){
            case 0:
                return "Gaussian";
                break;
            case 1:
                return "Flat";
                break;
            default:
                return "Flat";
                break;
        }
    }
    public set AFD_Shape(val:string){
        switch (val){
            case "Circular":
                this.AFDshape_rb_p.selected = 0;
                break;
            case "Elliptical":
                this.AFDshape_rb_p.selected = 1;
                break;
            case "Square":
                this.AFDshape_rb_p.selected = 2;
                break;
            case "Rectangular":
                this.AFDshape_rb_p.selected = 3;
                break;                        
        }
        this.update();
    }  
    public get AFD_Shape(){
        switch (this.AFDshape_rb_p.selected){
            case 0:
                return "Circular";
                break;
            case 1:
                return "Elliptical";
                break;
            case 2:
                return "Square";
                break;
            case 3:
                return "Rectangular";
                break;                
        }   
    } 

    public set apertureWidth(val:number){
        this.apertureWidth_sldr_p.value = val;
        this.update();
    }  
    public get apertureWidth(){
        return this.apertureWidth_sldr_p.value;
    }
    public set apertureLength(val:number){
        this.apertureLength_sldr_p.value = val;
        this.update();
    }  
    public get apertureLength(){
        return this.apertureLength_sldr_p.value;
    }    
    public set AFD_Width(val:number){
        this.AFDwidth_sldr_p.value = val;
        this.update();
    }  
    public get AFD_Width(){
        return this.AFDwidth_sldr_p.value;
    }  
    public set AFD_Length(val:number){
        this.AFDlength_sldr_p.value = val;
        this.update();
    }  
    public get AFD_Length(){
        return this.AFDlength_sldr_p.value;
    }

    public set AFD_GaussianTaper(val:number){
        this.AFDtaper_sldr_p.value = val;
        this.update();
    }  
    public get AFD_GaussianTaper(){
        return this.AFDtaper_sldr_p.value;
    } 
   
    public set Npts(val:number){
        this.nPts_sldr_p.value = val;
        this.update();
    }  
    public get Npts(){
        return this.nPts_sldr_p.value;
    }  
    public set phasePointingX(val:number){
        this.phaseX_sldr_p.value = val;
        this.update();
    }  
    public get phasePointingX(){
        return this.phaseX_sldr_p.value;
    }
    public set phasePointingY(val:number){
        this.phaseY_sldr_p.value = val;
        this.update();
    }  
    public get phasePointingY(){
        return this.phaseY_sldr_p.value;
    }
       
    public get ds(){
        return this._ds;
    } 
    public set analysisSpan(val:number){
        this.analysisSpan_sldr_p.value = val;
        this.update();
    }     
    public get analysisSpan(){
        return this.analysisSpan_sldr_p.value;
    } 
    public get patternGaindBPerDiv():number{
        return this._patternGaindBPerDiv;
    }  
    public get patternDegPerDiv():number{
        return this._patternDegPerDiv;
    } 
    public get AFD_MagMax():number{
        return this._magMax;
    }
    public get AFD_MagPerDiv():number{
        return this._AFD_MagPerDiv;
    }  
    public get AFD_DperDiv():number{
        return this._AFD_DperDiv;
    } 
    public set showControls(val:boolean){
        this.stageSymbol.controls.visible = val;                                       
    }
    public get showControls(){
        return this.stageSymbol.controls.visible;                                        
    }

    public set lookatY(val:number){
        this._lookatY = val;
        this.redraw3D();
    }
    public get lookatY(){
        return this._lookatY;
    }
    public set cutNpoints(val:number){
        this._cutNpoints = val;
        this.updateCut();
    }
    public get cutNpoints():number{
        return this._cutNpoints;
    }
    public set cutSpan(val:number){
        this._cutSpan = val;
        this.updateCut();
    }
    public get cutSpan():number{
        return this._cutSpan;
    }   
    public set cutTheta(val:number){
        this.cutDial_p.val = val;
        this.updateCut();
    }
    public get cutTheta():number{
        return this.cutDial_p.val;
    } 
    public set cutCenterOffset(val:number){
        this.cutSlider_p.value = val;
        this.updateCut();
    }
    public get cutCenterOffset():number{
        return this.cutSlider_p.value;
    }     

    public get cutX():Array<number>{
        return this._cutX;
    }
    public get cutValues():Array<number>{
        return this._cutValues;
    }
    public set showCut(val:boolean){
        //console.log("In set showCut = "+val);
        this.cutEnable_cb_p.selected = val;
        this.updateCut();
    }
    public get showCut(){
        return this.cutEnable_cb_p.selected;
    }
    public set showLeftSideDetails(val:boolean){
        this._showLeftSideDetails = val;
        this.updateLayout();
    }
    public get showLeftSideDetails(){
        return this._showLeftSideDetails;
    }
    public set showRightSideDetails(val:boolean){
        this._showRightSideDetails = val;
        this.updateLayout();
    }
    public get showRightSideDetails(){
        return this._showRightSideDetails;
    } 
    public set syncPanelViews(val:boolean){
        if (val){
            this.syncPanel2ViewtoPanel1()
        }
        this._syncPanelViews = val;               
    }
    public get syncPanelViews(){
        return this._syncPanelViews;               
    } 

}

